import { render, staticRenderFns } from "./AppModels.vue?vue&type=template&id=fb965332&scoped=true&"
import script from "./AppModels.vue?vue&type=script&lang=js&"
export * from "./AppModels.vue?vue&type=script&lang=js&"
import style0 from "./AppModels.vue?vue&type=style&index=0&id=fb965332&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb965332",
  null
  
)

export default component.exports